<div class="slide-builder" [ngClass]="{ 'export-pdf-mode': exportMode }" [slideBackgroundContext]="slideData()">
  @for (section of slideData()?.items; track section; let first = $first; let last = $last) {
    <app-slide-builder-section
      [class.no-sections-gap]="noGap()"
      [section]="section"
      [isFirstSection]="first"
      [isLastSection]="last"
      [requiredToWatchVideo]="requiredToWatchVideo()"
      [chapterContainerHeight]="chapterContainerHeight()"
      [requiredToCompleteInteraction]="requiredToCompleteInteraction()"
      [parentContainerHeight]="containerHeight() - 40"
      [sectionMinHeight]="section?.minHeight"
      [sectionContainerHeight]="chapterContainerHeight()"
      (videoWatched)="emitVideoWatched($event)"
      (answerChanged)="slideAnswerChanged($event)"
      (interactionCompleted)="slideInteractionCompleted($event)">
    </app-slide-builder-section>
  }
</div>
